import ApiServiceWrapper from './../../api-request.service';
import { MswApiStatusResponse } from '@/shared/types/api-common-types';

const downloadCenter = 'downloads/';
const downloadCenterApi = {
  getActivateSoftwareDownload(id: string) {
    const reqEndPoint = `${downloadCenter}activate-software-download?userName=${id}`;
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  postActivateSoftwareDownload(id: string, choice: Number) {
    const reqEndPoint = `${downloadCenter}activate-software-download?userName=${id}&choiceID=${choice}`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  getApplicableSoftwareGroups(userName: string, langCode: string) {
    let reqEndPoint = `${downloadCenter}get-applicableSoftwareGroups?userName=${userName}`;
    if (langCode) {
      reqEndPoint = `${reqEndPoint}&langCode=${langCode}`;
    }
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  getApplicableSoftwareGroupsWithLang(id: string, lang: string) {
    const reqEndPoint = `${downloadCenter}get-applicableSoftwareGroups?userName=${id}&langCode=${lang}`;
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  getApplicableDownloads(obj : any) {
    const reqEndPoint = `${downloadCenter}get-applicabledownloads`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, obj);
  },
  addToDownloadCenter(obj: any) {
    const reqEndPoint = `${downloadCenter}add-mydownloads`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, obj);
  },
  removeFromDownloadCenter(obj: any) {
    const reqEndPoint = `${downloadCenter}remove-mydownloads`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, obj);
  },
  getApecPlatformOptions() {
    const reqEndPoint = `${downloadCenter}get-softwaretype-platform`;
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  postGetApecSupportChart(obj : any) {
    const reqEndPoint = `${downloadCenter}get-aepc-support-chart`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, obj);
  },
};

export default downloadCenterApi;
